/**
 * Tiny helpers to format a ticket / queue number to its new
 * "Lettre + 3 chiffres" code (e.g. C001, M015).
 *
 * The backend started attaching `code` (and `queueLetter`) to every ticket
 * created after the format change. For tickets minted before the upgrade,
 * we recompute the display string from `queueLetter` + `number` (and finally
 * fall back to the raw number so nothing breaks).
 */
export function formatTicketCode(ticket) {
  if (!ticket) return "—";
  if (ticket.code) return ticket.code;
  const letter = ticket.queueLetter;
  const n = ticket.number;
  if (letter && Number.isFinite(n)) return `${letter}${String(n).padStart(3, "0")}`;
  if (Number.isFinite(n)) return String(n);
  return "—";
}

/**
 * Format an arbitrary {letter, number} pair into a ticket code.
 * Used by queue payloads exposing `currentNumber` / `nextNumber` separately.
 */
export function formatCode(letter, number) {
  if (!Number.isFinite(number) || number === null || number === undefined) return null;
  if (letter) return `${letter}${String(number).padStart(3, "0")}`;
  return String(number);
}
